import { render, staticRenderFns } from "./WordGrexy.vue?vue&type=template&id=64c17225&scoped=true"
import script from "./WordGrexy.vue?vue&type=script&lang=js"
export * from "./WordGrexy.vue?vue&type=script&lang=js"
import style0 from "./WordGrexy.vue?vue&type=style&index=0&id=64c17225&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c17225",
  null
  
)

export default component.exports